import template from './report_time_logged.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportTimeLoggedViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);

		this.table_report = ko.observableArray();
		this.download_data = ko.observableArray();
		this.download_data_summary = ko.observableArray();
		this.can_download = ko.observable(false);
		this.show_hint = ko.observable(true);
		this.show_no_data_message = ko.observable(false);
		this.search_query = ko.observable('')

		this.current_page = ko.observable(1);
		this.items_per_page = ko.observable(10);
		this.total_items = ko.observable(0);
		this.available_page_sizes = ko.observableArray([10, 20, 50, 100]);
		// Sorting
		this.sort_field = ko.observable('start_time');
		this.sort_order = ko.observable('ASC');


		let fromDate = new Date();
		fromDate.setDate(1);

		this.from_filter = ko.observable(Utils.toJSONDateString(fromDate));
		this.to_filter = ko.observable(Utils.toJSONDateString(new Date())); 

		this.selected_display = ko.observable('time_logged_rg'); 
		this.selected_search = ko.observable('employee_rg'); 
		this.summary_total_hours = ko.observable(0);
		this.summary_employees_count = ko.observable(0)
		this.table_visible = ko.observable(false);

		this.current_department_id = ko.observable();
		this.current_employee_id = ko.observable();
		this.current_company_id = ko.observable();

		this.selected_company = ko.observable();
		this.selected_employee = ko.observable();
		this.selected_department = ko.observable();
		this.download_data_daily_summary = ko.observableArray();

		this.total_pages = ko.computed(() => {
			return Math.ceil(this.total_items() / this.items_per_page());
		});

		this.selected_search.subscribe(() => {
			this.table_visible(false);
			this.can_download(false);
		});

		this.selected_display.subscribe((value) => {
			this.page.load_entries();
		});

		this.selected_company.subscribe((newValue) => {
			if (newValue != null)
				this.current_company_id(newValue.company_id);
			else
				this.current_company_id(null);
		});

		this.selected_department.subscribe((newValue) => {
			if (newValue != null)
				this.current_department_id(newValue.department_id);
			else
			{
				this.current_department_id(null);
				this.page.updateData();
			}
		});

		this.selected_employee.subscribe((newValue) => {
			if (newValue != null)
				this.current_employee_id(newValue.employee_id);
			else
				this.current_employee_id(null);
		});

		this.grouped_download_data = ko.computed(() => {
			const data = this.download_data();
			const grouped = {};
			
			data.forEach(entry => {
				if (!grouped[entry.name]) {
					grouped[entry.name] = [];
				}
				grouped[entry.name].push(entry);
			});
			
			// Convert to array of objects for easier template binding
			return Object.keys(grouped).map(name => ({
				employee_name: name,
				entries: grouped[name]
			}));
		});
		
		// Add computed observable to group summary data by employee
		this.grouped_download_data_summary = ko.computed(() => {
			const data = this.download_data_summary();
			const grouped = {};
			
			data.forEach(entry => {
				if (!grouped[entry.name]) {
					grouped[entry.name] = [];
				}
				grouped[entry.name].push(entry);
			});
			
			// Convert to array of objects for easier template binding
			return Object.keys(grouped).map(name => ({
				employee_name: name,
				entries: grouped[name]
			}));
		});
	}

	async view_entry(row)
	{
		row.view_only = true;
		await Grape.dialog.open('LogTime', { row: row, employee_id: this.current_employee_id() });
	}

	async delete_entry(row)
	{
		let response = await Grape.alerts.confirm({type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to delete the entry?')});
		if (response)
		{
			let res = await Grape.fetches.postJSON('/time_management/remove_task_time', { task_time_id: row.task_time_id , approval_status: 'waiting'});
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully removed time logged entry.') , title: tr('Success') });
				this.page.load_time_table();
			}
			else if (res.status == 'ERROR')
			{
				Grape.alerts.apiError(res);
				this.page.load_time_table();
			}
			else if (res.error)
			{
				Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error') });
				this.page.load_time_table();
			}
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		}
	}

	async edit_entry(row)
	{
		await Grape.dialog.open('LogTime', { row: row , employee_id: this.current_employee_id() });
		this.page.load_time_table();
	}

	async btn_download_click()
	{
		let id;
		let res;
		try
		{
			if (this.selected_display() == 'time_logged_rg')
			{
				res = await this.download_time_logged();
				id = 'tbl_time_logged';
			}
			else if (this.selected_display() == 'tasks_summary_rg')
			{
				res = await this.download_summary();
				id = 'tbl_summary';
			}
			else
				throw new Error('Invalid display option selected');

			Grape.alerts.alert({ type: 'warning', message: tr('Report is currently being downloaded with the current options selected on the screen.') });

			// Only generate CSV if we have data
			let has_data = (this.selected_display() == 'time_logged_rg' && this.download_data().length > 0) ||
				(this.selected_display() == 'tasks_summary_rg' && this.download_data_summary().length > 0);

			if (!has_data) 
			{
				Grape.alerts.alert({ type: 'warning', message: tr('No data available to download') });
				return;
			}

			let summary_csv = this.generate_summary_table_csv();
			let main_table = await Utils.table_to_csv(document.getElementById(id));

			// Remove unwanted rows from CSV
			main_table = main_table.split('\n').filter(row => {
				// Filter out empty rows and alert message rows
				return row.trim() !== '' && 
					   !row.includes('No data found') && 
					   !row.includes('Please click load result to load data');
			}).join('\n');

			let csv_string = summary_csv + '\n\n' + main_table;

			if (csv_string === null || csv_string === undefined || csv_string === '')
				throw new Error('Failed to generate CSV data');

			let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
			let link = document.createElement('a');
			link.href = URL.createObjectURL(blob);
			link.setAttribute('download', `${id}_report.csv`);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		}
		catch (error)
		{
			console.error('Error in btn_download_click:', error);
			Grape.alerts.alert({ type: 'error', message: tr('Failed to download report data: ') + error.message, title: tr('Error') });
		}
	}

	async download_time_logged() {
		try {
			let table_query_options = await this.set_table_query_options();
			if (!table_query_options)
				return 'invalid';
			else {
				let res = await Grape.fetches.postJSON('/time_management/get_time_logged_report', table_query_options);
				if (res.status == 'OK') {
					if (res.report != null && res.report != undefined && res.report.time_logged) {
						// Process timestamps
						for (let entry of res.report.time_logged) {
							const startDate = new Date(entry.start_time);
							entry.start_time = Utils.get_timestamp(startDate);
							
							if (entry.end_time) {
								const endDate = new Date(entry.end_time);
								entry.end_time = Utils.get_timestamp(endDate);
							}
						}
						
						this.download_data(res.report.time_logged);
						this.summary_total_hours(res.report.total_hours);
						this.summary_employees_count(res.report.total_employees);
						this.show_no_data_message(false);
						return true;
					} else
						return 'nodata';
				}
				return false;
			}
		} catch (error) {
			console.error('Error in download_time_logged:', error);
			Grape.alerts.alert({ type: 'Error', message: tr('Something went wrong when downloading the time logged table'), title: tr('Error')});
		}
	}

	async download_summary()
	{
		try
		{
			let table_query_options = await this.set_table_query_options(); 
			let res = await Grape.fetches.postJSON('/time_management/get_task_summary', table_query_options);
			if (res.report != null && res.report != undefined && res.report.time_logged)
			{
				this.download_data_summary(res.report.time_logged);
				this.summary_total_hours(res.report.total_hours);
				this.summary_employees_count(res.report.total_employees);
				return true;
			}
			return 'nodata';
		} catch (error)
		{
			console.error('Error in download_summary:', error);
			Grape.alerts.alert({ type: 'Error', message: tr('Something went wrong when downloading the task summary table'), title: tr('Error')});
		}
	}

	//removed daily summary table download since we dont have a daily_summary
	show_report_help()
	{
		Grape.dialog.open('ReportTimeLoggedHelp', { employee_id: this.page.bindings.id });
	}

	generate_summary_table_csv()
	{
		let csv_content = 'Total hours,Number of employees\n';
		csv_content += `${this.summary_total_hours()},${this.summary_employees_count()}\n`;
		return csv_content;
	}

	async set_table_query_options()
	{
		let table_query_options = {
			offset: 0,
			limit: 1000000000,
			start_date: this.from_filter(),
			end_date: this.to_filter()
		};

		if (this.selected_search() == 'employee_rg')
		{
			if (!this.current_employee_id())
			{
				Grape.alerts.alert({type: 'warning', message: tr('Please select an employee.'), title: tr('Error')});
				return;
			}
			else
			{
				table_query_options.employee_id =  this.current_employee_id();
				return table_query_options;
			}
		} 
		else if (this.selected_search() == 'company_rg')
		{
			if (!this.current_company_id())
			{
				Grape.alerts.alert({type: 'warning', message: tr('Please select a company.'), title: tr('Error')});
				return;
			}
			else
			{
				table_query_options.company_id =  this.current_company_id();
				return table_query_options;
			}
		}
		else if (this.selected_search() == 'department_rg')
		{ 
			if ( !this.current_department_id())
			{
				Grape.alerts.alert({type: 'warning', message: tr('Please select a company or department.'), title: tr('Error')});
				return;
			}
			else
			{
				table_query_options.company_id = this.current_company_id();
				table_query_options.department_id = this.current_department_id();
				return table_query_options;
			}
		}
		else
			return;
	}

	async view_entry(row)
	{
		row.view_only = true;
		await Grape.dialog.open('LogTime', { row: row });
		this.page.load_entries();
	}
}

class ReportTimeLoggedPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportTimeLoggedViewModel(this);
	}

	init()
	{
		document.title = tr('Logged Time Report');
		window.current_page_title(tr('Logged Time Report'));
	}

	updateData()
	{
		this.viewModel.table_visible(false);
		this.viewModel.download_data([]);
		this.viewModel.download_data_summary([]);
	}

	async load_entries()
	{
		this.viewModel.show_hint(false);
		this.viewModel.can_download(true);
		this.viewModel.loader(true);
		this.viewModel.table_visible(false);
		if (this.viewModel.to_filter() < this.viewModel.from_filter())
		{
			Grape.alerts.alert({ type: 'error', title: tr('Error'), message: tr('To date cannot be before from date') });
			return;
		}

		if (this.viewModel.selected_display() === 'time_logged_rg')
			await this.load_time_table();
		else if (this.viewModel.selected_display() === 'tasks_summary_rg')
			await this.load_tasks_table();
		
		this.viewModel.loader(false);
	}

	async load_tasks_table()
	{
		let table_query_options = await this.viewModel.set_table_query_options();
		if (!table_query_options) return;
	
		table_query_options.sortfield = 'task_description';
		table_query_options.sortorder = 'ASC';
	
		if (this.viewModel.search_query().trim().length > 0)
		{
			table_query_options.filter = [
				{
					field: 'name',
					op: 'ILIKE',
					value: '%' + this.viewModel.search_query().trim() + '%'
				}
			];
		}
	
		let res = await Grape.fetches.postJSON('/time_management/get_task_summary', table_query_options);
		console.log('results', res)
		if (res.report != null && res.report != undefined)
		{
			if (res.report.time_logged != null)
			{
				this.viewModel.summary_total_hours(res.report.total_hours);
				this.viewModel.summary_employees_count(res.report.total_employees);
				this.viewModel.download_data_summary(res.report.time_logged);
				this.viewModel.table_visible(true);
				this.viewModel.show_no_data_message(false); // Add this line
			}
			else
			{
				this.viewModel.table_visible(false);
				this.viewModel.download_data_summary([]);
				this.viewModel.show_no_data_message(true);
			}
		}
	}

	async load_time_table()
	{
		let table_query_options = await this.viewModel.set_table_query_options();

		if (!table_query_options)
			return;

		table_query_options.sortfield = 'start_time';
		table_query_options.sortorder = 'ASC';
		let res = await Grape.fetches.postJSON('/time_management/get_time_logged_report', table_query_options);
		console.log('results', res)
		if (res.report != null && res.report != undefined)
		{
			if (res.report.time_logged != null)
			{
				// Process timestamps
				for (let entry of res.report.time_logged)
				{
					let start_date = new Date(entry.start_time);
					entry.start_time = Utils.get_timestamp(start_date);

					if (entry.end_time)
					{
						let end_date = new Date(entry.end_time);
						entry.end_time = Utils.get_timestamp(end_date);
					}
				}

				this.viewModel.summary_total_hours(res.report.total_hours);
				this.viewModel.summary_employees_count(res.report.total_employees);
				this.viewModel.download_data(res.report.time_logged);
				this.viewModel.table_visible(true);
				this.viewModel.show_no_data_message(false); // Add this line
			} else {
				this.viewModel.table_visible(false);
				this.viewModel.download_data([]);
				this.viewModel.show_no_data_message(true);
			}
		}
	}
}

export default {
	route: '[/]time_management/report_time_logged',
	page_class: ReportTimeLoggedPage,
	template: template,
	template_filename: 'translation/report_time_logged'
};
